import { prepareAutoplayAudioElement, resetAutoplayAudioElementForTests } from "~/lib/autoplayAudioElement";

type UnlockListener = () => void;

const gestureEvents = ["click", "keydown", "mousedown", "pointerdown", "touchstart"] as const;

let started = false;
let unlocked = false;
const listeners = new Set<UnlockListener>();

function notifyListeners() {
  for (const listener of listeners) {
    listener();
  }
}

function removeGestureListeners() {
  for (const eventName of gestureEvents) {
    window.removeEventListener(eventName, handleGesture);
  }
}

function handleGesture() {
  if (unlocked) {
    return;
  }

  unlocked = true;
  notifyListeners();
}

export function startAutoplayUnlockTracking(): void {
  if (started || typeof window === "undefined") {
    return;
  }

  started = true;
  prepareAutoplayAudioElement();

  for (const eventName of gestureEvents) {
    window.addEventListener(eventName, handleGesture, { passive: true });
  }
}

export function isAutoplayUnlocked(): boolean {
  return unlocked;
}

export function subscribeToAutoplayUnlock(listener: UnlockListener): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function resetAutoplayUnlockForTests(): void {
  if (typeof window !== "undefined") {
    removeGestureListeners();
  }

  started = false;
  unlocked = false;
  listeners.clear();
  resetAutoplayAudioElementForTests();
}
